import classNames from 'classnames'
import React from 'react'

const MobileLayout = ({ children, className = '' }) => {
  return (
    <div
      className={classNames(
        'relative mx-auto min-h-screen max-w-lg lg:max-w-5xl xl:max-w-6xl',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default MobileLayout
